import gql from 'graphql-tag';

export default gql`
  mutation deleteAsset($assetId: String!) {
    deleteAsset(assetId: $assetId) {
      assetId
    }
  }
`;
